import { Component, OnChanges, OnInit } from '@angular/core';
import { Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';
import { FieldItem } from 'src/app/models/common/field-item';

@Component({
  selector: '',
  template: '',
})
export class AgentQuestionHandlerComponent extends BaseComponent<AgentService> implements OnChanges {
  public isQuestionReplyOneShow: boolean = false;
  public isQuestionReplyTwoShow: boolean = false;
  public isQuestionReplyThreeShow: boolean = false;
  public isQuestionReplyFourShow: boolean = false;
  public isQuestionReplyFiveShow: boolean = false;
  public isQuestionReplySixShow: boolean = false;
  public isQuestionReplySevenShow: boolean = false;
  public isQuestionReplyEightShow: boolean = false;
  public isQuestionReplyNineShow: boolean = false;
  public isQuestionReplyTenShow: boolean = false;
  public isQuestionReplyElevenShow: boolean = false;
  public isQuestionReplyTwelveShow: boolean = false;

  public detailOne: string | null = null;
  public detailTwo: string | null = null;
  public detailThree: string | null = null;
  public detailFour: string | null = null;
  public detailFive: string | null = null;
  public detailSix: string | null = null;
  public detailSeven: string | null = null;
  public detailEight: string | null = null;
  public detailNine: string | null = null;
  public detailTen: string | null = null;
  public detailEleven: string | null = null;
  public detailTwelve: string | null = null;

  // Mapping `fieldcd` to component properties
  private readonly fieldToPropertyMap: {
    [key: string]: {
      showProperty: keyof AgentQuestionHandlerComponent;
      detailProperty: keyof AgentQuestionHandlerComponent;
    };
  } = {
    questionReplyOne: { showProperty: 'isQuestionReplyOneShow', detailProperty: 'detailOne' },
    questionReplyTwo: { showProperty: 'isQuestionReplyTwoShow', detailProperty: 'detailTwo' },
    questionReplyThree: { showProperty: 'isQuestionReplyThreeShow', detailProperty: 'detailThree' },
    questionReplyFour: { showProperty: 'isQuestionReplyFourShow', detailProperty: 'detailFour' },
    questionReplyFive: { showProperty: 'isQuestionReplyFiveShow', detailProperty: 'detailFive' },
    questionReplySix: { showProperty: 'isQuestionReplySixShow', detailProperty: 'detailSix' },
    questionReplySeven: { showProperty: 'isQuestionReplySevenShow', detailProperty: 'detailSeven' },
    questionReplyEight: { showProperty: 'isQuestionReplyEightShow', detailProperty: 'detailEight' },
    questionReplyNine: { showProperty: 'isQuestionReplyNineShow', detailProperty: 'detailNine' },
    questionReplyTen: { showProperty: 'isQuestionReplyTenShow', detailProperty: 'detailTen' },
    questionReplyEleven: { showProperty: 'isQuestionReplyElevenShow', detailProperty: 'detailEleven' },
    questionReplyTwelve: { showProperty: 'isQuestionReplyTwelveShow', detailProperty: 'detailTwelve' },
  };

  constructor(agentService: AgentService) {
    super(agentService);
  }

  ngOnInit() {
    super.ngOnInit();

    const questionData = this.service.responseIO.data.QuestionList[0];
    console.log('data ===', questionData);

    // Dynamically setting the properties based on the questionData or item fields
    if (questionData) {
      for (const key in this.fieldToPropertyMap) {
        if (Object.prototype.hasOwnProperty.call(questionData, key)) {
          const property = this.fieldToPropertyMap[key];
          const fieldValue = questionData[key];
          if (fieldValue) {
            (this[property.showProperty] as boolean) = fieldValue === 'Y';
          }
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
  onInputChanged(item: FieldItem) {
    const property = this.fieldToPropertyMap[item.fieldCd];
    if (property) {
      (this[property.showProperty] as boolean) = item.fieldValue === 'Y';
      if (item.fieldValue === 'N') this.service.setModelFieldValue(item.model, property.detailProperty, null);
    } else {
      console.warn(`Unhandled fieldcd: ${item.fieldCd}`);
    }
  }
}
